import React, {
  ChangeEvent,
  FC,
  FocusEvent,
  KeyboardEventHandler,
  useEffect,
  useState,
} from 'react'
import Layout from './Layout'
import useQuery from '@components/Items/utils/hooks/useQuery'

const Msrp = () => {
  const [{ msrpTo, msrpFrom }, { updateQuery }] = useQuery()

  return (
    <Layout label={'MSRP'}>
      <Field
        label="Min"
        defaultValue={msrpFrom || ''}
        name="msrpFrom"
        handleChange={(newValue) => {
          updateQuery('msrpFrom', newValue)
        }}
        validation={['min', msrpTo || '']}
      />
      <Field
        label="Max"
        defaultValue={msrpTo || ''}
        name="msrpTo"
        handleChange={(newValue) => {
          updateQuery('msrpTo', newValue)
        }}
        validation={['max', msrpFrom || '']}
      />
    </Layout>
  )
}

const Field: FC<{
  label: string
  name: string
  defaultValue: string
  handleChange: (newValue: string) => void
  validation: [limit: 'min' | 'max', limitValue: string]
}> = ({
  label,
  name,
  defaultValue,
  handleChange,
  validation: [limit, limitValue],
}) => {
  const [inputValue, setInputValue] = useState<string>(defaultValue)

  useEffect(() => {
    setInputValue(defaultValue)
  }, [defaultValue])

  const onChange = (e: ChangeEvent<HTMLInputElement>): void => {
    if (isNaN(Number(e.target.value))) return
    setInputValue(e.target.value)
  }

  const handleBlur = (e: FocusEvent<HTMLInputElement>): void => {
    const newInput = inputValue
      ? formatPrice(
          limitValue
            ? String(Math[limit](Number(inputValue), Number(limitValue)))
            : inputValue
        )
      : ''

    if (newInput !== defaultValue) {
      handleChange(newInput)
    }
  }

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = (e) => {
    if (e.key === 'Enter') {
      const newInput = inputValue
        ? formatPrice(
            limitValue
              ? String(Math[limit](Number(inputValue), Number(limitValue)))
              : inputValue
          )
        : ''

      setInputValue(newInput)
      handleChange(newInput)
    }
  }

  return (
    <div className="flex gap-2 items-center">
      <label
        htmlFor="price"
        className="block text-sm font-medium leading-6 text-gray-900 w-8"
      >
        {label}:
      </label>
      <div className="relative mt-2 rounded-md shadow-sm">
        <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
          <span className="text-gray-500 sm:text-sm">$</span>
        </div>
        <input
          id="price"
          name={name}
          type="text"
          placeholder="0.00"
          aria-describedby="price-currency"
          value={inputValue}
          onChange={onChange}
          onBlur={handleBlur}
          onKeyDown={onKeyDown}
          className="block w-full rounded-md border-0 py-1.5 pl-7 pr-12 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
        />
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
          <span id="price-currency" className="text-gray-500 sm:text-sm">
            USD
          </span>
        </div>
      </div>
    </div>
  )
}

const formatPrice = (value: string): string => {
  const number = parseFloat(value)
  return isNaN(number) ? '' : number.toFixed(2)
}

export default Msrp
